import { defineComponent as _defineComponent } from 'vue'
import IconLogo from '@/components/icons/IconLogo.vue';
import ChoosePlanTable from '@/components/ChoosePlanTable.vue';
import PromocodeModal from '@/components/PromocodeModal.vue';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PlanView',
  setup(__props) {

const promocode = ref();
const modalOpenState = ref();

function handleAddPromocode() {
    modalOpenState.value = true;
}

function handleClose() {
    modalOpenState.value = false;
}

function handleSavePromocode(code: string) {
    promocode.value = code;
}

function handleRemovePromocode() {
    promocode.value = null;
}

return { __sfc: true,promocode, modalOpenState, handleAddPromocode, handleClose, handleSavePromocode, handleRemovePromocode, IconLogo, ChoosePlanTable, PromocodeModal }
}

})